var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncfail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D72C0D",
  d: "M19.834 3.896A11.667 11.667 0 1 1 2.339 14.378l-.006-.379.006-.378a11.667 11.667 0 0 1 17.495-9.725m-7.571 6.767a1.167 1.167 0 0 0-1.421 1.828l1.507 1.508-1.507 1.509-.097.11a1.166 1.166 0 0 0 1.747 1.54L14 15.65l1.509 1.508.11.096a1.166 1.166 0 0 0 1.54-1.746L15.65 14l1.507-1.509.097-.11a1.167 1.167 0 0 0-1.746-1.54L14 12.35l-1.508-1.508-.11-.096z"
})));
export { SvgSyncfail as ReactComponent };
export default __webpack_public_path__ + "static/media/sync.fail.76a14c88.svg";